import React from "react"
import { Routes as RTS, Route } from "react-router-dom";
import { BrowserView, MobileView, TabletView } from "react-device-detect";
import HomeBrowserUI from "../Component/Home/UI/Browser/Home";
import HomeMobileUI from "../Component/Home/UI/Mobile/Home";



const Routes = () => {
    return (
        <RTS>

            <Route path="/*" element={
                <div>

                    <BrowserView>
                        <HomeBrowserUI />
                    </BrowserView>
                    <MobileView>
                        <HomeMobileUI />
                    </MobileView>
                    <TabletView>
                        <HomeMobileUI />
                    </TabletView>
                </div>



            } />
        </RTS>
    )
}

export default Routes